module.exports = __webpack_public_path__ + "static/media/cinnamon.7054c8d5.png";